import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditarPedido5 from "../../referencias-tablas/pedidos/EditarPedido5";
import { COLOR_MARCA } from "./constantes";

// Edición del pedido en un diálogo (la tabla y sus filtros quedan como estaban).
// Usa el formulario de la V1 sin cambios: handleCloseEdicion se llama al cancelar y al guardar.
function DialogEditarPedido({ pedido, onClose }) {
  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ bgcolor: COLOR_MARCA, color: "#fff", pr: 6 }}>
        Editar pedido #{pedido.id_pedido} · {pedido.cliente}
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8, color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: "16px !important" }}>
        <EditarPedido5 datos={pedido} handleCloseEdicion={onClose} />
      </DialogContent>
    </Dialog>
  );
}

export default DialogEditarPedido;
